<template>
  <div class="container">
    <!--banner-->
    <div class="nban pc">
      <img src="@/view/images/y40.jpg" />
      <div class="nbana">
        <p>
          <router-link to="/solution2?navaa=1">蜂享优印解决方案</router-link>
        </p>
        <p class="on">
          <router-link to="/solution1?navaa=1">印刷数字化工厂解决方案</router-link>
        </p>
        <p>
          <router-link to="/solution?navaa=1">印刷管家服务解决方案</router-link>
        </p>
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- <div class="mbx pc">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">解决方案</a></p>
      </div>
    </div> -->
    <!--印刷数字化智能工厂解决方案-->
    <div class="neiy">
      <div class="commen">
        <div class="nbana mob">
          <p class="">
            <router-link to="/solution2?navaa=1">蜂享优印解决方案</router-link>
          </p>
          <p class="on">
            <router-link to="/solution1?navaa=1"
              >印刷数字化工厂解决方案</router-link
            >
          </p>
          <p>
            <router-link to="/solution?navaa=1"
            >印刷管家服务解决方案</router-link
            >
          </p>
          <div class="clearfix"></div>
        </div>
        <div class="fa2a">
          <div class="bt reveal-solutiontop">
            <h6>大多数印刷企业的智能化现状</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa2aa">
            <div class="fa2ab fl reveal-solutiontop">
              <div class="fa2ab_a">
                <img src="@/view/images/y31.png" />
                <p>信息孤岛</p>
              </div>
              <div class="fa2ab_b">
                <p>
                  当前企业的信息系统都是由许多独立的基于事务处理的管理子系统和基于实时操作的工厂子系统组成，系统与系统之间不兼容，系统与设备不通讯，设备与设备不联通，使整个工厂遍布一座座信息孤岛。
                </p>
              </div>
            </div>
            <div class="fa2ab fl reveal-solutiontop">
              <div class="fa2ab_a">
                <img src="@/view/images/y31.png" />
                <p>依赖人力</p>
              </div>
              <div class="fa2ab_b">
                <p>
                  虽数字化但仍依赖人力进行生产串联，收集完整、
                  可靠的数据化信息非常困难。而工人技能在下降，工资在上涨，使得管理成本激增的矛盾凸显。
                </p>
              </div>
            </div>
            <div class="fa2ab fl reveal-solutiontop">
              <div class="fa2ab_a">
                <img src="@/view/images/y31.png" />
                <p>技术纷乱</p>
              </div>
              <div class="fa2ab_b">
                <p>
                  市场上有形态各异的管理系统，大多管理系统的逻辑都是财务逻辑、IT逻辑，与实际生产格格不入，所以看着很美，卖得很贵，用着很累。
                </p>
              </div>
            </div>
            <div class="fa2ab fl reveal-solutiontop">
              <div class="fa2ab_a">
                <img src="@/view/images/y31.png" />
                <p>投入巨大</p>
              </div>
              <div class="fa2ab_b">
                <p>
                  新闻中业内率先试水智能化升级的企业，无不规模庞大，斥资数千万，投入大量人力物力，使得绝大部分中小企业望而却步。
                </p>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="bt reveal-solutiontop">
          <h6>印刷数字化工厂解决方案</h6>
          <img src="@/view/images/y8.png" />
        </div>
      </div>
      <div class="fa2b">
        <div class="commen1">
          <div class="fa2ba reveal-solutiontop">
            <p>
              印工社核心团队由软件开发、智能控制和传感、高等院校学者及知名印刷企业管理者等专家组成，凭借多年的技术积淀与行业经验，<br /><span
                >为印刷企业提供印刷标准化、数字化、信息化、智能化的低成本解决方案。</span
              ><br /><br />印刷智能化工厂是指印刷行业的生产化与数字化，两化合一而形成的以精益生产为管理思想，依托互联网技术形成的现代化印刷工厂模式。<br />印刷智能化工厂解决方案，从客户调研到报价到订单到生产到交货，实现印刷全业务流程信息化数字化。<br />实现智能生产，提高产能可视化。
            </p>
          </div>
          <div class="fa2bb reveal-solutiontop">
            <img src="@/view/images/y43.png" />
          </div>
        </div>
      </div>
      <div class="fa2c">
        <div class="commen1">
          <div class="bt reveal-solutiontop">
            <h6>模块内容</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="ysxa">
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y7.jpg" />
              <div class="ysb_w">
                <h6>ERP企业资源计划系统</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>ERP企业资源计划系统</h6>
                  <p>
                    提供跨地区、跨部门甚至跨公司整合实时信息的企业管理信息系统。实现了企业内部资源和企业相关的外部资源的整合。通过软件把企业的人、财、物、产、供销及相应的物流、信息流、资金流、管理流、增值流等紧密地集成起来实现资源优化和共享。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y9.jpg" />
              <div class="ysb_w">
                <h6>APS高级计划与排程</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>APS高级计划与排程</h6>
                  <p>
                    解决顺序和调度的优化问题，助力企业提升项目管理与项目制造效率，优化关键链资源配置，降低综合成本与交付周期。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y43.jpg" />
              <div class="ysb_w">
                <h6>CRM客户资源管理</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>CRM客户资源管理</h6>
                  <p>
                    CRM客户关系管理系统，是指利用软件、硬件和网络技术，为企业建立一个客户信息收集、管理、分析和利用的信息系统。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y8.jpg" />
              <div class="ysb_w">
                <h6>BI商业智能</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>BI商业智能</h6>
                  <p>
                    用现代数据仓库技术、线上分析处理技术、数据挖掘和数据展现技术进行数据分析以实现商业价值。通过应用基于事实的支持系统来辅助商业决策的制定。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y10.jpg" />
              <div class="ysb_w">
                <h6>PLM产品生命周期管理</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>PLM产品生命周期管理</h6>
                  <p>
                    应用于在单一地点的企业内部、分散在多个地点的企业内部，以及在产品研发领域具有协作关系的企业之间的，支持产品全生命周期的信息的创建、管理、分发和应用的一系列应用解决方案，能够集成与产品相关的人力资源、流程、应用系统和信息。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y11.jpg" />
              <div class="ysb_w">
                <h6>CMS色彩管理系统</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>CMS色彩管理系统</h6>
                  <p>
                    在色彩失真最小的前提下，将颜色信息从一个色彩空间转换到另一个色彩空间的过程。目的是保证同样的颜色信息从输入到显示、输出整个过程中表现的外观尽可能相同，最终达到原稿与复制品的色彩一致性匹配。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y15.jpg" />
              <div class="ysb_w">
                <h6>MES制造执行系统</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>MES制造执行系统</h6>
                  <p>
                    通过信息传递对从订单下达到产品完成的整个生产过程进行优化管理。并对实时事件及时做出反应、报告，并用当前的准确数据对它们进行指导和处理。通过双向的直接通讯在企业内部和整个产品供应链中提供有关产品行为的关键任务信息。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y12.jpg" />
              <div class="ysb_w">
                <h6>WMS仓储管理系统</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>WMS仓储管理系统</h6>
                  <p>
                    一个实时的计算机软件系统，它能够按照运作的业务规则和运算法则，对信息、资源、行为、存货和分销运作进行更完美地管理，提高效率。管理仓库作业的结果记录、核对和管理，并对仓库作业过程的指导和规范。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y13.jpg" />
              <div class="ysb_w">
                <h6>QMS 质量管理体系</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>QMS 质量管理体系</h6>
                  <p>
                    制定质量方针、目标以及质量策划、质量控制、质量保证和质量改进等活动。实现质量管理的方针目标，有效地开展各项质量管理活动。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y44.jpg" />
              <div class="ysb_w">
                <h6>CPS感知设备</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>CPS感知设备</h6>
                  <p>
                    CPS是在环境感知的基础上，深度融合计算、通信和控制能力的可控可信可扩展的网络化物理设备系统。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y14.jpg" />
              <div class="ysb_w">
                <h6>IIOT工业物联设备</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>IIOT工业物联设备</h6>
                  <p>
                    将具有感知、监控能力的各类采集、控制传感器或控制器，以及移动通信、智能分析等技术不断融入到工业生产过程各个环节，从而大幅提高制造效率，改善产品质量，降低产品成本和资源消耗，最终实现将传统工业提升到智能化的新阶段。从应用形式上，工业物联网的应用具有实时性、自动化、嵌入式(软件)、安全性、和信息互通互联性等特点。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y45.jpg" />
              <div class="ysb_w">
                <h6>AIDS扫码设备</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>AIDS扫码设备</h6>
                  <p>在工业互联网中频繁使用到的各类扫码设备。</p>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- <div class="jj_m"><a @click="TOsolution">了解更多</a></div> -->
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="fa2d">
        <div class="commen">
          <div class="bt reveal-solutiontop">
            <h6>印刷数字化工厂解决方案特点</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa2da">
            <div class="fa2db fl reveal-solutiontop">
              <img src="@/view/images/y46.png" />
              <h6>计划执行一体化</h6>
              <p>
                将设备与设备、终端管理、云端空间相互联，消除信息孤岛，使计划决策与生产执行的之间紧密相连
              </p>
            </div>
            <div class="fa2db fl reveal-solutiontop">
              <img src="@/view/images/y47.png" />
              <h6>事务管理透明化</h6>
              <p>
                通过打造可视化，消除印刷工厂里的“黑匣子”，所有的事务管理都透明可视，避免滋生生产隐患
              </p>
            </div>
            <div class="fa2db fl reveal-solutiontop">
              <img src="@/view/images/y48.png" />
              <h6>数据采集实时化</h6>
              <p>
                通过与设备控制系统集成，以及外接传感器等方式，由SCADA实时采集设备的状态，生产完工的信息、质量信息，并通过应用RFID(无线射频技术)、条码等技术，实现生产过程的可追溯
              </p>
            </div>
            <div class="fa2db fl reveal-solutiontop">
              <img src="@/view/images/y49.png" />
              <h6>过程管控精益化</h6>
              <p>
                用数字化技术管控，在生产过程中贯彻精益生产的理念，能够实现按订单驱动，拉动式生产，推进标准化、模块化和系列化
              </p>
            </div>
            <!-- <div class="fa2db fl fa2dc reveal-solutiontop">
              <img src="@/view/images/y50.png" />
              <h6>现场作业少人化</h6>
              <p>
                运用工业机器人、视觉机器人等技术，把复杂繁琐的工艺流程用系统来代替人工，降低失误率，提高工作效率，减少管理成本
              </p>
            </div> -->
            <div class="fa2db fl fa2dc reveal-solutiontop">
              <img src="@/view/images/y50.png" />
              <h6>资源管控精细化</h6>
              <p>
                能够及时采集设备和产线的消耗，实现物料精准控制、高效利用，有效提高良品率，减少纸张、油墨等的浪费
              </p>
            </div>
            <div class="fa2db fl reveal-solutiontop">
              <img src="@/view/images/y51.png" />
              <h6>异常响应敏捷化</h6>
              <p>
                将安灯系统与手机终端、现场大屏等应用，可以随时监测排查异常报错，第一时间发现故障点，无需人工排查
              </p>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div class="fa2e">
        <div class="commen">
          <div class="bt reveal-solutiontop">
            <h6>印工社工业互联网技术架构</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa2ea reveal-solutiontop">
            <img src="@/view/images/framework.jpg" />
          </div>
        </div>
      </div>
      <div class="zngc">
        <img src="@/view/images/gif.gif" />
      </div>
    </div>
    <!--留言-->
    <!-- <div class="lyan reveal-solutiontop" style="margin-top: 0;"  >
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" type="text" value="您的公司" onfocus="if(value=='您的公司') {value=''}" onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" type="text" value="您的联系方式" onfocus="if(value=='您的联系方式') {value=''}" onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" onfocus="if(value=='您的需求'){value=''}" onblur="if (value ==''){value='您的需求'}">您的需求</textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
    <coun-sel></coun-sel>
  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0fb0c350f1482064e25902f9db8dec76";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
import $ from 'jquery'; // 在需要使用的页面中
// import scrollReveal from 'scrollreveal'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import CounSel from '@/components/counsel';

export default {
  name: 'solutionName',
  components: {
    CounSel,
  },
  data() {
    return {
      // scrollReveal: scrollReveal(),
      content: '您的需求',
      mobile: '您的联系方式',
      gongsi: '您的公司',
    };
  },
  methods: {
    TOsolution() {
      this.$router.push('solution?navaa=1');
    },
    init() {},
  },
  mounted() {
    // this.scrollReveal.reveal('.reveal-solutiontop', {
    //   origin: 'bottom',
    //   distance: '50px',
    //   duration: 600,
    //   reset: true,
    //   mobile: true,
    // })
    // this.scrollReveal.reveal('.reveal-left', {
    //   origin: 'left',
    //   distance: '30px',
    //   duration: 600,
    //   reset: true,
    //   mobile: true,
    // })
    // this.scrollReveal.reveal('.reveal-right', {
    //   origin: 'right',
    //   distance: '30px',
    //   duration: 600,
    //   reset: true,
    //   mobile: true,
    // })
    new Swiper('#swiper_fa1', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
    });
    new Swiper('#swiper_fa2', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
    });
    new Swiper('#swiper_fa3', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
    });
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
.pc .bannericon {
  width: 1600px;
}

.pc .bka_a {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/view/solution1.vue